/*  BSS Customer Offerings still found in customer.convergent.biller.selectors.js */
import { createSelector } from 'reselect';
import { MetadataConstants, MetadataSelectors } from 'invision-core';
import { pathOr } from 'ramda';
import { SelectedCustomerSelector } from './customer.selectors';
export var IsChangeOfferEligibilityRulesLoaded = createSelector([SelectedCustomerSelector], function (currentCustomer) {
  return pathOr(null, ['offerings', 'isLoadingChangeOfferEligibilityRules'], currentCustomer);
});
export var ChangeOfferEligibilityRulesSelector = createSelector([SelectedCustomerSelector], function (currentCustomer) {
  return pathOr(null, ['offerings', 'changeOfferEligibilityRules'], currentCustomer);
});
export var IsCoolingPeriodEnabledSelector = createSelector([MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.CoolingPeriod)], function (coolingPeriod) {
  return coolingPeriod.length > 1;
});